import { DOMAINE_NAME } from "./env";

export const URL = {
  // Companies
  TOTAL_COMPANIES: DOMAINE_NAME + "/modules/societes/api/total.php",
  LIST_COMPANIES: DOMAINE_NAME + "/modules/societes/api/index.php",
  GET_COMPANY: DOMAINE_NAME + "/modules/societes/api/getCompany.php",
  SUBMIT_COMPANY: DOMAINE_NAME + "/modules/societes/api/submitCompany.php",

  // Pages 
  LIST_PAGES: DOMAINE_NAME + "/modules/pages/api/getAllPages.php",

  // Cities
  GET_CITY: DOMAINE_NAME + "/modules/villes/api/getCity.php",
  GET_CITIES: DOMAINE_NAME + "/modules/villes/api/getCities.php",

  // Categories
  LIST_CATEGORIES: DOMAINE_NAME + "/modules/categories/api/index.php", //utiliser sur le homePage 
  LIST_ALL_CATEGORY: DOMAINE_NAME + "/modules/categories/api/getAllCategories.php", //Utiliser sur détaille categorier
  LIST_ALL_PROFESSION: DOMAINE_NAME + "/modules/categories/api/getAllProfession.php", //Utiliser sur détaille categorier
  PAGE_CATEGORY: DOMAINE_NAME + "/modules/pages/api/getSearchPage.php",
  GET_CATEGORY: DOMAINE_NAME + "/modules/categories/api/getCategory.php",

  // Categories Proffession
  LIST_CATEGORIES_PROFESSION: DOMAINE_NAME + "/modules/categories/api/index-professions.php", //utiliser sur le homePage 

  // Politique de confidentialité
  PRIVACY_POLICY: DOMAINE_NAME + "/modules/pages/api/show.php",

  // Contact
  SHOW_CONTACT: DOMAINE_NAME + "/modules/pages/api/showContact.php",
  SHOW_ADRESS: DOMAINE_NAME + "/modules/societes/api/showContactAdress.php",

  // Aide et soins à domicile
  SHOW_HELP: DOMAINE_NAME + "/modules/pages/api/showAide.php",
  PROFESSION: DOMAINE_NAME + "/modules/categories-groups/api/profession.php", // utilisation sur filtre
  SERVICE: DOMAINE_NAME + "/modules/categories-groups/api/service.php",// utilisation sur filtre
  SEO_CATEGORY: DOMAINE_NAME + "/modules/categories/api/showSEOCategories.php",
  SEO_COMPANY: DOMAINE_NAME + "/modules/societes/api/seo.php",

  FOOTER_TEXT: DOMAINE_NAME + "/modules/pages/api/showText.php",
  SEO_DATA: DOMAINE_NAME + "/modules/pages/api/showSEO.php",
  SEO_URLS: DOMAINE_NAME + "/modules/categories/api/permalink.php",

  //Newsletters
  NEWSLETTER: DOMAINE_NAME + "/modules/requests/api/sendNewsletter.php",

  //Demande en ligner
  ONLINE_REQUEST: DOMAINE_NAME + "/modules/requests/api/sendRequest.php",

  //Blog
  BLOG: DOMAINE_NAME + "/modules/news/api/index.php",  
  BLOG_SHOW: DOMAINE_NAME + "/modules/news/api/detail.php",  
  BLOG_SEO: DOMAINE_NAME + "/modules/categories/api/getMetaBySlug.php",  

  //À propos
  GET_ABOUT: DOMAINE_NAME + "/modules/pages/api/getPageById.php",

};
